<template>
  <div class="form-area">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div class="title">
        <span>{{ $t('profits.title_select_area') }}</span><br>
      </div>
      <el-row>
        <div class="el-col sidebar">
          <div
            class="region"
            v-for="(region, index) in this.$regions"
            :key="region.id"
            :class="index == this.$regions.length - 1 ? 'border-bottom' : '' "
            @click="selectRegion(index)"
          >
            <el-row :class="regionSelect == region.value ? 'selected' : ''">
              <div class="el-col" :class="regionSelect == region.value ? 'tab' : ''"></div>
              <div class="el-col" :class="regionSelect == region.value ? 'label-selected' : 'label'"><span>{{ region.name }}</span></div>
            </el-row>
          </div>
        </div>
        <div class="el-col prefecture">
          <div class="select-all">
            <el-checkbox :label="checkAll" @change="handleCheckAll" v-model="checkAll">
              {{ region.name }}  ({{ $t('all') }})
            </el-checkbox>
          </div>
          <div class="prefecture-item">
            <el-checkbox-group class="checkbox-search" v-model="tmpSelected" @change="handleSelect">
              <el-checkbox :label="item.id" :key="item.id" v-for="item in prefectures">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-row>
      <div class="list-selected">
        <span>{{ $t('profits.select_area.selected_area') }}：</span><br>
        <label v-for="area in Object.keys(textAreaSelected)" :key="area">
          <span v-if="textAreaSelected[area]"><span>{{ area }}：({{ textAreaSelected[area] }})</span><br></span>
        </label>
      </div>
      <div class="hint">
        <span class="label">{{ $t('profits.select_area.hint_result') }}：</span>
        <span class="result" v-if="quantityHint > 0"> {{ quantityHint }} </span>
        <span class="ken">{{ $t('profits.select_area.ken') }}</span>
      </div>
      <div class="footer">
        <el-button type="primary" @click="search" class="btn btn-search">{{ $t('profits.select_area.btn_search') }}</el-button>
        <el-button type="primary" @click="clear" class="btn btn-clear-select">{{ $t('profits.select_area.btn_clear') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { countFromPrefecture } from '../../api/prefecture'

  export default {
    props: {
      openDialogSelectArea: { type: Boolean, required: true, default: false },
      prefecturesGroup: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      selected: { type: Array, required: true, default: {} },
      areaSelected: { type: Array, required: true, default: {} },
      listAreaSelected: { type: Array, required: true, default: {} },
      isClear: { type: Boolean, required: true, default: false },
    },
    emits: ['closeDialogSelectArea', 'setListArea'],
    data() {
      return {
        dialog: false,
        loading: false,
        regionSelect: '1,2',
        prefectures: [],
        region: {},
        tmpSelected: [],
        checkAll: false,
        array: [],
        quantityHint: 0,
        textAreaSelected: {},
        prefecturesSelected: [],
        listPrectureIdOfRegion: [],
        selectedDup: {},
        selectedArea: {},
      };
    },
    methods: {
      handleClose() {

        const isSelectedDup = Object.keys(this.selectedDup).length;
        const isSelectedArea = Object.keys(this.selectedArea).length;
        const isSelected = Object.keys(this.selected).length;
        if ([isSelectedArea, isSelected].every(e => e === 0)) {
          Object.keys(this.selectedDup).forEach((f) => {
               this.selectedArea[f] = this.selectedDup[f]
               this.selected[f] = this.selectedDup[f]
            });
        } else if (isSelectedDup>0) {
          Object.keys(this.selectedArea).forEach((e, i) => {
            Object.keys(this.selectedDup).forEach((f) => {
              if (e === f) {
                this.selectedArea[e] = this.selectedDup[f]
              }
            });
          });
        }

        this.countFromPrefecture();
        this.selectRegion(0, this.regionSelect);
        this.$emit('closeDialogSelectArea', this.selectedArea);
      },

      selectRegion(index) {
        this.regionSelect = this.$regions[index].value;
        this.region = this.$regions[index];
        this.tmpSelected = this.selectedArea[this.region.name];
        this.prefectures = this.prefecturesGroup[this.region.name]
        this.isSelectedAll();
      },

      handleSelect(value) {
        this.selectedArea[this.region.name] = this.tmpSelected;
        this.isSelectedAll();
        this.countFromPrefecture();
        if (!this.tmpSelected) {
          return;
        }
        const listPrefectureName = [];
        this.tmpSelected.forEach(item => {
          const prefecture = this.prefectures.find(element => {
            return element.id == item;
          })
          listPrefectureName.push(prefecture.name);
        });
        this.textAreaSelected[this.region.name] = this.checkAll ? this.$t('all') : listPrefectureName.join("・");
      },

      handleCheckAll(value) {
        this.tmpSelected = [];
        if (value) {
          this.prefectures.forEach(item => {
            this.tmpSelected.push(item.id);
          });
          this.textAreaSelected[this.region.name] = this.$t('all');
        } else {
          this.textAreaSelected[this.region.name] = '';
        }

        this.selectedArea[this.region.name] = this.tmpSelected;

        this.countFromPrefecture();
      },

      checkPrefectureIsCurrentRegion(id) {
        this.prefectures.forEach(item => {
          if (item.id == id) {
            return true;
          }
        });

        return false;
      },

      isSelectedAll() {
        this.checkAll = (this.selectedArea[this.region.name] != null && (this.selectedArea[this.region.name].length == this.prefectures.length));
      },

      search() {
        Object.keys(this.selectedArea).forEach((e, i) => {
          this.selected[e] = this.selectedArea[e];
          let obj = this.selectedArea[e];
          if (obj === undefined || obj.length == 0) {
            delete this.selectedArea[e];
            delete this.selected[e];
          }
        });
        this.selectedDup = {...this.selectedArea};
        this.$emit('setListArea', this.selectedArea);
      },

      clear() {
        this.checkAll = false;
        Object.keys(this.selectedArea).forEach((e, i) => {
          delete this.selectedArea[e];
          delete this.selected[e];
        });
        this.tmpSelected = [];
        this.quantityHint = 0;
        this.textAreaSelected = [];
      },

      getListSelectedPrefectureId() {
        let prefectureIds = [];
        Object.keys(this.selectedArea).forEach(key => {
          prefectureIds = prefectureIds.concat([this.selectedArea[key]])
        });

        return prefectureIds;
      },

      countFromPrefecture() {
        const prefectureIds = this.getListSelectedPrefectureId();

        if (prefectureIds.length == 0) {
          this.quantityHint = 0;
          return;
        }

        countFromPrefecture({prefecture_ids: prefectureIds}, this.urls.count_result)
        .then(response => response.json())
        .then(response => {
          this.quantityHint = response.data;
        })
        .catch((error) => {})
      },

      getTextAreaSelected(arrSelected, arrAreaSelected) {
        let result = [];
        for (let i in arrAreaSelected) {
          if (Object.values(arrSelected).includes(arrAreaSelected[i].id)) {
            result.push(arrAreaSelected[i].name);
          }
        }
        return result.join("・");
      },
    },

    created() {
      this.dialog = this.openDialogSelectArea;
      this.tmpSelected = this.areaSelected;
      Object.keys(this.selected).forEach((e, i) => {
        let text = this.getTextAreaSelected(this.selected[e], this.areaSelected);
        this.textAreaSelected[e] =  text === '' ? this.$t('all') : text;
      });
      this.selectedArea = {...this.selected};
      this.selectedDup = {...this.selectedArea};

      this.isClear ? this.clear() : '';
      this.countFromPrefecture();
      this.selectRegion(0, this.regionSelect);
    },
  }
</script>

<style lang="scss">
  .form-area {
    text-align: left !important;
    .el-dialog {
      width: 760px;
      height: 689px;
    }
    .title {
      text-align: center;
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700;
      margin-bottom: 30px;
      .note {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 0.88px;
        color: #969696;
      }
    }
    .sidebar {
      padding-left: 30px;
      width: 180px;
      .region {
        height: 40px;
        background: #F7F3ED 0% 0% no-repeat padding-box;
        border: 1px solid #E9E5DF;
        border-bottom: 0px;
        font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
        letter-spacing: 0.96px;
        color: #000000;
        cursor: pointer;
        .selected {
          background: #FFFFFF 0% 0% no-repeat padding-box;
        }
        .tab {
          width: 8px;
          height: 40px;
          background: #B0893C 0% 0% no-repeat padding-box;
        }
        .label-selected {
          padding: 7px 0 0 20px;
        }
        .label {
          padding: 7px 0 0 28px;
        }
      }
      .border-bottom {
        border: 1px solid #E9E5DF;
      }
    }
    .prefecture {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E9E5DF;
      margin-left: 20px;
      width: calc(100% - 266px);
      .select-all {
        height: 40px;
        border-bottom: 1px solid #E9E5DF;
        padding: 7px 0 0 23px;
      }
      .prefecture-item {
        padding: 25px;
      }
      .el-checkbox {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 1.1px;
        color: #000000;
        --el-checkbox-font-size: 11px;
      }

    }

    .list-selected {
      margin-left: 30px;
      margin-top: 30px;
      padding: 10px 0px 0 20px;
      width: 88%;
      height: 90px;
      overflow-y: auto;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #DDD8D1;
      font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
      letter-spacing: 0.96px;
      color: #000000;
    }

    .hint {
      text-align: center;
      margin-top: 30px;
      .label {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 0.88px;
        color: #505050;
      }
      .result {
        font: normal normal bold 20px/17px Futura;
        letter-spacing: 0.2px;
        color: #B0893C;
      }
      .ken {
        font: normal normal bold 13px/17px Futura;
        letter-spacing: 0.13px;
        color: #B0893C;
      }
    }

    .footer {
      margin-top: 30px;
      padding-left: 32%;
      .btn-search {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px !important;
        border-radius: 25px !important;
      }
      .btn-clear-select {
        width: 98px;
        height: 25px;
        box-shadow: 0px 1px 2px #00000029;
        border: 1px solid #E5E5E5;
        font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
        letter-spacing: 1.2px;
        --el-button-text-color: #868686;
        --el-button-bg-color: #FDFDFD;
        --el-button-hover-bg-color: #FDFDFD;
        --el-button-hover-text-color: #868686;
        --el-button-active-bg-color: #FDFDFD;;
      }
    }

    .el-checkbox {
      --el-checkbox-checked-bg-color: #AC3B29;
      --el-checkbox-input-border-color-hover: #AC3B29;
      --el-checkbox-checked-icon-color: #FFFF;
      --el-checkbox-checked-input-border-color: #AC3B29;
      --el-checkbox-checked-text-color: #000000;
    }
  }
  .el-dialog__body {
    --el-dialog-padding-primary: 25px;
  }
</style>
